var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['spinner', _vm.extraClass, { 'spinner--top': _vm.isTopMobile }],style:(_vm.extraStyle)},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner__icon"},[_c('span',{staticClass:"spinner__item"}),_c('span',{staticClass:"spinner__item"}),_c('span',{staticClass:"spinner__item"}),_c('span',{staticClass:"spinner__item"})])
}]

export { render, staticRenderFns }